"use client";

import { useReducedMotion } from "@/lib/motion";
import { MarqueeRow } from "@/components/ui/marquee-row";
import { logos, STATS } from "@/lib/constants";

interface Props {
  name: string;
}

function LogoItem({ name }: Props) {
  return (
    <div
      role="img"
      aria-label={name}
      className="text-muted-foreground flex h-10 shrink-0 items-center px-7 text-lg font-semibold tracking-tight whitespace-nowrap select-none"
    >
      {name}
    </div>
  );
}

export default function TrustedBySection() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section
      className="border-border overflow-hidden border-y"
      aria-label="Trusted by teams worldwide"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-8 sm:flex-row sm:items-center sm:gap-6 sm:px-6 lg:px-8">
        <p className="text-muted-foreground shrink-0 text-sm font-medium sm:max-w-42">
          Trusted by {STATS.customers} of teams worldwide:
        </p>

        <div className="relative min-w-0 flex-1">
          <ul className="sr-only">
            {logos.map((logo) => (
              <li key={logo.name}>{logo.name}</li>
            ))}
          </ul>
          {prefersReducedMotion ? (
            <div className="flex overflow-hidden" aria-hidden="true">
              {logos.map((logo) => (
                <LogoItem key={logo.name} name={logo.name} />
              ))}
            </div>
          ) : (
            <MarqueeRow
              items={logos}
              duration="60s"
              copies={2}
              renderItem={(logo, i) => <LogoItem key={`${logo.name}-${i}`} name={logo.name} />}
            />
          )}

          {/* Edge fades — wordmarks dissolve into the page at both ends of the strip */}
          <div
            className="from-background pointer-events-none absolute inset-y-0 left-0 w-16 bg-linear-to-r to-transparent sm:w-24"
            aria-hidden="true"
          />
          <div
            className="from-background pointer-events-none absolute inset-y-0 right-0 w-16 bg-linear-to-l to-transparent sm:w-24"
            aria-hidden="true"
          />
        </div>
      </div>
    </section>
  );
}
